class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    
    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener('change', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      const pathname = event.state && event.state.pathname ? event.state.pathname : window.location.pathname;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false, pathname);
    }
    window.addEventListener('popstate', onHistoryChange);
    document.addEventListener('click', FacetFiltersForm.onVehicleMakeClick, true);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true, pathname = window.location.pathname) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const baseUrl = `${pathname}?section_id=${section.section}`;
      const url = searchParams ? `${baseUrl}&${searchParams}` : baseUrl;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams, pathname);
  }

  static renderPageByUrl(nextUrl, event, updateURLHash = true) {
    const parsedUrl = new URL(nextUrl, window.location.origin);
    if (updateURLHash) {
      history.pushState({ searchParams: parsedUrl.search.slice(1), pathname: parsedUrl.pathname }, '', `${parsedUrl.pathname}${parsedUrl.search}`);
    }
    FacetFiltersForm.renderPage(parsedUrl.search.slice(1), event, false, parsedUrl.pathname);
    FacetFiltersForm.syncVehicleMakeState(parsedUrl.search);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    
  }
  static renderReview() {
    if (window.SPR && theme.review ) {
      if ($('.shopify-product-reviews-badge').length > 0) {
        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
      };
    }
  }
  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    FacetFiltersForm.syncVehicleMakeState();
  }

  static getVehicleMakeUrl(input) {
    return FacetFiltersForm.getVehicleMakeToggleUrl(input.dataset.vehicleMake || input.value);
  }

  static getVehicleMakeToggleUrl(value, search = window.location.search, pathname = window.location.pathname) {
    const url = new URL(`${pathname}${search}`, window.location.origin);
    const make = FacetFiltersForm.normalizeVehicleMakeHandle(value);
    const availableMakes = FacetFiltersForm.getAvailableVehicleMakes();
    const selectedMakes = FacetFiltersForm.getSelectedVehicleMakes(url.search)
      .filter((selectedMake) => availableMakes.length === 0 || availableMakes.includes(selectedMake));
    const nextMakes = new Set(selectedMakes);

    if (nextMakes.has(make)) {
      nextMakes.delete(make);
    } else {
      nextMakes.add(make);
    }

    if (nextMakes.size > 0) {
      url.searchParams.set('vehicle_make', Array.from(nextMakes).join(','));
    } else {
      url.searchParams.delete('vehicle_make');
    }

    url.searchParams.delete('section_id');
    url.searchParams.delete('page');
    return `${url.pathname}${url.search}`;
  }

  static getAvailableVehicleMakes() {
    return Array.from(document.querySelectorAll('[data-vehicle-make]'))
      .map((input) => FacetFiltersForm.normalizeVehicleMakeHandle(input.dataset.vehicleMake || input.value))
      .filter(Boolean);
  }

  static onVehicleMakeClick(event) {
    const target = event.target;
    if (!target || !target.closest) return;

    const input = target.closest('[data-vehicle-make]') ||
      (target.closest('a') && target.closest('a').querySelector('[data-vehicle-make]')) ||
      (target.closest('label') && target.closest('label').querySelector('[data-vehicle-make]'));

    if (!input) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.href = FacetFiltersForm.getVehicleMakeToggleUrl(input.dataset.vehicleMake || input.value);
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    FacetFiltersForm.syncVehicleMakeState();
    theme.wishlist.load();
    theme.compare.load();
    theme.countdown.load();
    theme.swatchCard2.load();
    FacetFiltersForm.renderReview();
    
  }

  static normalizeVehicleMakeHandle(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[_\s]+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/^-+|-+$/g, '')
      .replace(/^make-/, '');
  }

  static getSelectedVehicleMakes(search = window.location.search) {
    const params = new URLSearchParams(search);
    const selectedMakes = params.get('vehicle_make');
    if (!selectedMakes) return [];

    return selectedMakes
      .split(',')
      .map((make) => FacetFiltersForm.normalizeVehicleMakeHandle(make))
      .filter(Boolean);
  }

  static syncVehicleMakeState(search = window.location.search) {
    const selectedMakes = FacetFiltersForm.getSelectedVehicleMakes(search);

    document.querySelectorAll('[data-vehicle-make]').forEach((input) => {
      const make = FacetFiltersForm.normalizeVehicleMakeHandle(input.dataset.vehicleMake || input.value);
      input.checked = selectedMakes.includes(make);
      input.removeAttribute('onclick');

      const nextUrl = FacetFiltersForm.getVehicleMakeToggleUrl(make, search);
      input.dataset.facetUrl = nextUrl;

      const link = input.closest('a');
      if (link) link.setAttribute('href', nextUrl);
    });

    FacetFiltersForm.applyVehicleMakeProductFilter(search);
    return;
  }

  static applyVehicleMakeProductFilter(search = window.location.search) {
    const selectedMakes = FacetFiltersForm.getSelectedVehicleMakes(search);
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    const productItems = Array.from(productGrid.querySelectorAll('.grid__item'));
    if (productItems.length === 0) return;

    let visibleCount = 0;

    productItems.forEach((item) => {
      const productMakes = String(item.dataset.vehicleMakes || '')
        .split('|')
        .map((make) => FacetFiltersForm.normalizeVehicleMakeHandle(make))
        .filter(Boolean);
      const matches = selectedMakes.length === 0 || selectedMakes.some((make) => productMakes.includes(make));

      item.hidden = !matches;
      item.style.display = matches ? '' : 'none';
      if (matches) visibleCount += 1;
    });

    const emptyMessage = document.querySelector('[data-vehicle-make-empty]');
    if (emptyMessage) emptyMessage.remove();

    if (selectedMakes.length > 0) {
      FacetFiltersForm.updateVehicleMakeProductCount(visibleCount);

      if (visibleCount === 0) {
        const message = document.createElement('div');
        message.className = 'collection collection--empty';
        message.setAttribute('data-vehicle-make-empty', '');
        message.innerHTML = '<div class="title-wrapper text-center"><h2 class="title title--primary h4">No products found</h2></div>';
        productGrid.insertAdjacentElement('afterend', message);
      }
    }
  }

  static updateVehicleMakeProductCount(count) {
    const countText = `${count} ${count === 1 ? 'product' : 'products'}`;
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    if (countContainer) countContainer.innerHTML = countText;
    if (countContainerDesktop) countContainerDesktop.innerHTML = countText;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams, pathname = window.location.pathname) {
    history.pushState({ searchParams, pathname }, '', `${pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    if (event.target && event.target.dataset && event.target.dataset.vehicleMake) {
      window.location.href = FacetFiltersForm.getVehicleMakeUrl(event.target);
      return;
    }
    if (event.target && event.target.dataset && event.target.dataset.facetUrl) {
      FacetFiltersForm.renderPageByUrl(event.target.dataset.facetUrl, event);
      return;
    }
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
document.addEventListener('DOMContentLoaded', () => FacetFiltersForm.syncVehicleMakeState());

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
  
    this.setMinAndMaxValues();
    this.noUifilter();
  }

  onRangeChange(event) {
   
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.noUifilter();
    
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
  

  noUifilter(){
    var $range = $(".sliderFilter"),
        $inputFrom = $(".field__input_min"),
        $inputTo = $(".field__input_max"),
        instance,
        min =  parseFloat($range.data('min')),
        max = parseFloat($range.data('max')),
        from = $inputFrom.val() ? $inputFrom.val() : 0,
        to = $inputTo.val() ? $inputTo.val() : max,
        formDesktop = document.getElementById('FacetFiltersForm'),
        formMobile = document.getElementById('FacetFiltersFormMobile');
    $range.ionRangeSlider({
      skin: "round",
        type: "double",
        min: min,
        max: max,
        from: from,
        to: to,
        onChange: updateInputs,
        onFinish: updateInputs
    });
     instance = $range.data("ionRangeSlider");
    function updateInputs (data) {
        from = data.from;
        to = data.to;
        $inputFrom.val(from);
        $inputTo.val(to);
        //document.getElementById('FacetFiltersForm').dispatchEvent(new Event("input"));
        
        $(window).resize(function() {
          var width = $(window).width();
          if (width > 750){
            formDesktop == null ? formMobile.dispatchEvent(new Event("input")) : formDesktop.dispatchEvent(new Event("input"));
          }
          else{
            formMobile.dispatchEvent(new Event("input"));
          }
        });
        $(window).width(function() {
          var width = $(window).width();
          if (width > 750){
            formDesktop == null ? formMobile.dispatchEvent(new Event("input")) : formDesktop.dispatchEvent(new Event("input"));
          }
          else{
            formMobile.dispatchEvent(new Event("input"));
          }
        });
        // document.getElementById('FacetFiltersFormMobile').dispatchEvent(new Event("input"));
    }
      $inputFrom.on("change", function () {
        var val = $(this).prop("value");
        // validate
        if (val < min) {
            val = min;
        } else if (val > to) {
            val = to;
        }
        instance.update({
            from: val
        });
        $(this).prop("value", val);
    });
    
    $inputTo.on("change", function () {
        var val = $(this).prop("value");
        // validate
        if (val < from) {
            val = from;
        } else if (val > max) {
            val = max;
        }
        instance.update({
            to: val
        });
        $(this).prop("value", val);
    });
  }

}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
    
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
